export default "__VITE_ASSET__DS2baGF4__"